import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { logOutApp } from '../GlobalModules/Login/Actions/LoginAction';
import NotFoundPage from '../../src/GlobalModules/Utility/Pages/NotFound';
import Header from '../../src/GlobalModules/Utility/Components/Header';
import Footer from '../GlobalModules/Utility/Components/Footer';
import FAB from '../GlobalModules/Utility/Components/FAB/FAB'
import { faPlus, faShoppingCart, faBox, faUtensils } from '@fortawesome/free-solid-svg-icons';
import './Auth.scss';
import { Link, useParams, useLocation } from 'react-router-dom';
import Utility from '../GlobalModules/Utility/Utility'

const POSLayout = (props) => {
  const { lng } = useParams();
  const location = useLocation();
  const { userCredentials, logOutApp, history, allowedRoles } = props;
  const [showNotFound, setShowNotFound] = useState(false);

  
  // Permission helper function
  const hasPermission = (userType, roleKey, index, eventKey, allowedRules) => {
    if (userType === 'admin') return true;
    const role = Utility.getRoleObjectByEventKey(roleKey);
    if (!role || !role.subeventKey || role.subeventKey.length <= index) return false;
    const sub = role.subeventKey[index];
    return sub.eventKey === eventKey && allowedRules.includes(sub.rules);
  };

  const userType = userCredentials?.user_details?.user_type;

  // Initially check user credentials are valid or not
  useEffect(() => {
    checkForUserCredentials();
  }, []);

  // User credentials checking and redirection fn
  const checkForUserCredentials = () => {
    if (props.token == undefined || props.token == "") {
      history.push("/");
    }
    if (!props.token || props.token === "" || !allowedRoles.includes(userCredentials.user_details.user_type)) {
      const timer = setTimeout(() => {
        setShowNotFound(true);
      }, 100);
      return () => clearTimeout(timer);
    }
  };

  return (
    <>
      {props.token && props.token !== "" && allowedRoles.includes(userCredentials.user_details.user_type) ?
        <div className={`app-layout pos-layout${props.currentStore?.is_procurement_hub ? ` store-theme-${(props.currentStore?.store_type || 'COST_CENTER').toLowerCase()}` : ''}`}>
          <Header history={props.history} />
          <div className="app-container">
            {/* No sidebar included for POS layout */}
            <div className="container-fluid p-0">
              <div className="no-gutters">
                <div className="col-12">
                  <main className={`main-content ${location.pathname.includes('/restaurant/kitchen-display') ||
                      location.pathname.includes('/sales/orders/add') || 
                      location.pathname.includes('/sales/digital-menu-orders')
                      ? 'special-layout-class'
                      : ''
                    }`}>
                    {props.children}
                  </main>
                </div>
              </div>
              <Footer />
            </div>
          </div>
          {/* Floating Action Button for quick actions with multiple options */}
          {(() => {
            const newOrderVisible = (['admin'].includes(userType) || (Object.keys(Utility.getRoleObjectByEventKey('sales_and_orders')).length > 0 && hasPermission(userType, 'sales_and_orders', 2, 'orders', ['CRUD', 'CUD'])));
            const newProductVisible = (['admin'].includes(userType) || (Object.keys(Utility.getRoleObjectByEventKey('stock')).length > 0 && hasPermission(userType, 'stock', 0, 'products', ['CRUD', 'CUD'])));
            
            if (!newOrderVisible && !newProductVisible) {
              return null;
            }
            
            return (
              <FAB
                icon={faPlus}
                tooltip="Quick Actions"
                color="primary"
                position="bottom-right"
                direction="up"
                options={[
                  {
                    component: <Link to={`/${lng}/stock/products/add`} />,
                    icon: faBox,
                    color: "success",
                    tooltip: "New Product",
                    // isVisible: true
                    isVisible: newProductVisible
                  },
                  {
                    component: <Link to={`/${lng}/sales/orders/add`} />,
                    icon: faShoppingCart,
                    color: "primary",
                    tooltip: "New Order",
                    // isVisible: true
                    isVisible: newOrderVisible
                  },
                  {
                    component: <Link to={`/${lng}/sales/orders/add`} />,
                    icon: faUtensils,
                    tooltip: 'Table View',
                    color: 'success',
                    isVisible: newOrderVisible
                  },
                ]}
              />
            );
          })()}
        </div>
        :
        showNotFound && <NotFoundPage permission={false} history={props.history} />
      }
    </>
  );
};

const mapStateToProps = (globalState) => {
  return {
    leftbar: globalState.mainReducerData.leftbar,
    userCredentials: globalState.LoginReducer.userCredentials,
    token: globalState.LoginReducer.token,
    currentStore: globalState.StoreReducer.currentStore,
  };
};

export default connect(mapStateToProps, { logOutApp })(POSLayout);
